import {
  PORTAL_POST_LIST_REQUEST, PORTAL_POST_LIST_SUCCESS, PORTAL_POST_LIST_FAIL,
  PORTAL_POST_LIST_BY_IDS_REQUEST, PORTAL_POST_LIST_BY_IDS_SUCCESS, PORTAL_POST_LIST_BY_IDS_FAIL,
  PORTAL_POST_DETAILS_REQUEST, PORTAL_POST_DETAILS_SUCCESS, PORTAL_POST_DETAILS_FAIL, PORTAL_POST_DETAILS_RESET,
  PORTAL_POST_CREATE_REQUEST, PORTAL_POST_CREATE_SUCCESS, PORTAL_POST_CREATE_FAIL,
  PORTAL_POST_UPDATE_REQUEST, PORTAL_POST_UPDATE_SUCCESS, PORTAL_POST_UPDATE_FAIL,
  PORTAL_POST_DELETE_REQUEST, PORTAL_POST_DELETE_SUCCESS, PORTAL_POST_DELETE_FAIL,
  PORTAL_POST_DTO_REQUEST, PORTAL_POST_DTO_SUCCESS, PORTAL_POST_DTO_FAIL,
} from '../constants/portalPostConstants';

export const portalPostListReducer = (state = { portalPosts: [] }, action) => {
  switch (action.type) {
    case PORTAL_POST_LIST_REQUEST:
      return { loading: true, portalPosts: [] };
    case PORTAL_POST_LIST_SUCCESS:
      return {
        loading: false,
        portalPosts: action.payload.items,
        totalPages: action.payload.totalPages,
        currentPage: action.payload.currentPage,
        totalCount: action.payload.totalCount,
      };
    case PORTAL_POST_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const portalPostListByIdsReducer = (state = { portalPosts: [] }, action) => {
  switch (action.type) {
    case PORTAL_POST_LIST_BY_IDS_REQUEST:
      return { loading: true, portalPosts: [] };
    case PORTAL_POST_LIST_BY_IDS_SUCCESS:
      return { loading: false, portalPosts: action.payload,
            };
    case PORTAL_POST_LIST_BY_IDS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const portalPostDetailsReducer = (state = { portalPost: {} }, action) => {
  switch (action.type) {
    case PORTAL_POST_DETAILS_REQUEST:
      return { loading: true, ...state };
    case PORTAL_POST_DETAILS_SUCCESS:
      return { loading: false, portalPost: action.payload };
    case PORTAL_POST_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case PORTAL_POST_DETAILS_RESET:
      return { portalPost: {} };
    default:
      return state;
  }
};

export const portalPostDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case PORTAL_POST_DELETE_REQUEST:
      return { loading: true };
    case PORTAL_POST_DELETE_SUCCESS:
      return { loading: false, success: true };
    case PORTAL_POST_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const portalPostCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case PORTAL_POST_CREATE_REQUEST:
      return { loading: true };
    case PORTAL_POST_CREATE_SUCCESS:
      return { loading: false, success: true, portalPost: action.payload };
    case PORTAL_POST_CREATE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const portalPostUpdateReducer = (state = { portalPost: {} }, action) => {
  switch (action.type) {
    case PORTAL_POST_UPDATE_REQUEST:
      return { loading: true };
    case PORTAL_POST_UPDATE_SUCCESS:
      return { loading: false, success: true, portalPost: action.payload };
    case PORTAL_POST_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const portalPostDtoReducer = (state = { portalPostDto: {} }, action) => {
  switch (action.type) {
    case PORTAL_POST_DTO_REQUEST:
      return { loading: true, portalPostDto: {} };
    case PORTAL_POST_DTO_SUCCESS:
      return { loading: false, portalPostDto: action.payload };
    case PORTAL_POST_DTO_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
